import Layout from "../components/Layout.vue"
import { createRouter, createWebHashHistory, RouteRecordRaw, NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import { getToken, getUserId } from "../utils/auth"
import { getRole } from "../utils/permission"
import enumValue from "../utils/enum"
import { messageWarning } from "../utils/message"

// 定义路由元数据类型
interface RouteMeta {
  requiresAuth?: boolean;
  requireAdmin?: boolean;
  title?: string;
}

// 定义路由记录类型
const routes: Array<RouteRecordRaw & { meta?: RouteMeta; requireAdmin?: boolean }> = [
    {
        path: '/app',
        component: Layout,
        children: [
            {
                path: "list",
                name: "appList",
                component: () => import("@/components/AppList.vue"),
                meta: { requiresAuth: true, requireAdmin: false }
            }
        ]
    },
    {
        path: '/user',
        component: Layout,
        children: [
            {
                path: "list",
                name: "userList",
                component: () => import("@/components/User.vue"),
                meta: { requiresAuth: true, requireAdmin: true }
            }
        ]
    },
    {
        path: '/manufacturer',
        component: Layout,
        children: [
            {
                path: "list",
                name: "manufacturerList",
                component: () => import("@/components/Manufacturer.vue"),
                meta: { requiresAuth: true, requireAdmin: false },
            },
            {
                path: "appList",
                name: "manufacturerAppList",
                component: () => import("@/components/ManufacturerAppList.vue"),
                meta: { requiresAuth: true, requireAdmin: false }
            },
        ]
    },
    {
        path: '/developer',
        component: Layout,
        children: [
            {
                path: "list",
                name: "developerList",
                component: () => import("@/components/Developer.vue"),
                meta: { requiresAuth: true, requireAdmin: false },
            },
        ],
    },
    {
        path: "/spider",
        component: Layout,
        children: [
            {
                path: "list",
                name: "spiderList",
                component: () => import("@/components/Spider.vue"),
                meta: { requiresAuth: true, requireAdmin: false }
            },
        ],
    },
    {
        path: "/stat",
        component: Layout,
        children: [
            {
                path: "info",
                name: "statInfo",
                component: () => import("@/components/Stat.vue"),
                meta: { requiresAuth: true, requireAdmin: false }
            },
            {
                path: "country",
                name: "statCountry",
                component: () => import("@/pages/StatCountry/StatCountry.vue"),
                meta: { requiresAuth: true, requireAdmin: false }
            },
        ],
    },
    { path: '/user/login', name: "login", component: () => import("@/components/Login.vue"), requireAdmin: false },
    { path: '/user/register', name: "register", component: () => import("@/components/Register.vue"), requireAdmin: false },
    { path: '/', redirect: "/app/list", requireAdmin: false },
    {
        path: '/:pathMatch(.*)*',
        component: () => import("@/pages/404.vue"),
        meta: {
            title: '找不到页面'
        }
    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHashHistory(),
    routes
})

// 导航守卫
router.beforeEach((to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const token = getToken();
    console.log(token);
    
    // 验证是否登录
    if (to.meta.requiresAuth && token === "") {
        return next({
            path: '/user/login',
            query: { redirect: to.fullPath },
        });
    }
    
    // 验证权限
    if (to.meta.requireAdmin) {
        const role = getRole(getUserId());
        if (role !== enumValue.permissionAdmin) {
            messageWarning("权限不足，不能访问该页面,请登陆对应账户");
            return next({
                path: '/user/login',
                query: { redirect: to.fullPath },
            });
        }
    }
    
    next();
})

export default router;